<template>
  <div class="content-box web-joins">
    <el-image src="/static/imgs/jion.png" fit="cover" class="w-img" />
    <el-image src="/static/imgs/phone/Rectangle2162@2xs.png" fit="cover" class="p-img" />
    <div class="web-join">
      <div class="joins w1200">
        <div class="dis jointit">
          <div>职位名称</div>
          <div>薪资待遇</div>
          <div>学历要求</div>
          <div>工作地点</div>
          <div>查看详情</div>
        </div>
        <div class="joinlist dis" v-for="(item,index) in arrs" :key="index" v-if="arrs.length">
          <div>{{item.title}}</div>
          <div>{{item.salary}}</div>
          <div>{{item.education}}</div>
          <div>{{item.department}}</div>
          <div @click="seeDeta(index)" class="sees">查看详情</div>
        </div>
      </div>
      <pagesK :tootle="total" :page-size="5" @counterchange="counterchange" />
      <el-dialog :visible.sync="dialogVisible" width="70%" :show-close="true">
        <div class="artit">
          <span>职位详情</span>
        </div>
        <div class="artcont">
          <div class="neirong">
            <div class="gangwei">{{form.title}}</div>
            <div class="bgf">
              <div class="tiao">
                <div class="over hbar">
                  <div class="fl">工作地点 {{form.working_place}}</div>
                  <div class="fl m45s">招聘人数 {{form.numbers}}</div>
                </div>
              </div>
              <div class="zwms">
                <div class="zwmstit">职位描述</div>
                <div class="zwmscont">{{form.responsibilities}}</div>
              </div>
              <div class="zwms">
                <div class="zwmstit">职位要求</div>
                <div class="zwmscont">{{form.requirements}}</div>
              </div>
            </div>
          </div>
        </div>
        <div class="h50"></div>
      </el-dialog>
    </div>
    <div class="p-join w92">
      <div v-for="(item,index) in arrs" :key="index" v-if="arrs.length" class="p-list" @click="gotoArt(item.id)">
        <div class="dis p-lin">
          <div class="p-1">{{item.title}}</div>
          <div class="p-2">{{item.salary}}</div>
        </div>
        <div class="dis">
          <div class="p-3">{{item.working_place}} | {{item.education}}</div>
          <div class="p-4">查看详情</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import pagesK from '@/components/page'
  export default {
    data() {
      return {
        dialogVisible: false,
        page: 1,
        total: 0,
        arrs: [],
        form: {},

      }
    },

    mounted() {

      this.getData(this.page)
    },

    components: {
      pagesK
    },
    methods: {
      counterchange(e) {
        this.page = e
        this.getData(e)

      },

      getData(p) {
        this.$request('get', this.$otapi + 'items/recruits?status=published&page=' + p + '&limit=5&meta=*&filter={"status":"published"}', {}, (res) => {
          if (res.status == 200) {
            this.arrs = res.data.data
            this.total = res.data.meta.filter_count
          }
        })
      },
      gotoArt(id) {
        this.$router.push({
          path: '/join/article',
          query: {
            id: id
          }
        });
      },
      seeDeta(i) {
        this.dialogVisible = true
        this.form = this.arrs[i]
      }
    },
    metaInfo() {
      return {
        title: '聚木网-加入我们'
      }
    }
  }
</script>
<style scoped>
  @import url('../../../static/css/join.css');
</style>



// WEBPACK FOOTER //
// src/components/join/index.vue